export const menuData = [
  {
    category: 'Skin Care',
    link: '/Skin-Care-Products',
    megaMenu: {
      left: {
        col1: [
          {
            heading: 'Acne',
            items: [
              { name: 'Sebosal', link: '/product/SkinCare/Sebosal' },
              { name: 'Seblok – 5mg', link: '/product/SkinCare/Seblok5' },
              { name: 'Seblok – 10mg', link: '/product/SkinCare/Seblok10' },
              { name: 'Seblok – 20mg', link: '/product/SkinCare/Seblok20' }
            ]
          },

          {
            heading: 'Skin Soothing',
            items: [
              { name: 'Hydew Face', link: '/product/SkinCare/Hydew-Face' },
              { name: 'Hydew Body Lotion', link: '/product/SkinCare/hydewbodylotion' },
              { name: 'Hydew PM', link: '/product/SkinCare/HYDewPM' },
              { name: 'Cutam palm & Sole', link: '/product/SkinCare/cutam' },
              { name: 'Angel Dew', link: '/product/SkinCare/angeldew' }
            ]
          }
        ],
        col2: [

          {
            heading: 'Photoaging',
            items: [
              { name: 'Ageret', link: '/product/SkinCare/ageret' },
              { name: 'Azelite', link: '/product/SkinCare/azelite' },
              { name: 'Niaa Serum', link: '/product/SkinCare/niaa-serum' }
            ]
          },
          {
            heading: 'Photoprotection',
            items: [
              { name: 'BioUV 32 SPF', link: '/product/SkinCare/BioUV32' },

              { name: 'BioUV 50 SPF', link: '/product/SkinCare/BioUV50' },
              { name: 'BioUV 50+ Spray', link: '/product/SkinCare/BioUV50Spray' },

              { name: 'BioUV Fluid SPF 50', link: '/product/SkinCare/BioUVFluid' },
              { name: 'BioUV MINERAL', link: '/product/SkinCare/BioUVMineral' }
            ]
          },
          {
            heading: 'Psoriasis',
            items: [
              { name: 'SoraLite', link: '/product/SkinCare/SoraLite' },
              { name: 'eStaar solution', link: '/product/SkinCare/eStaar' },
              { name: 'Pesklo', link: '/product/SkinCare/Pesklo' },
              { name: 'Cue-On', link: '/product/SkinCare/CueON' },
              { name: 'Tazdone', link: '/product/SkinCare/Tazdone' }
            ]
          }
        ],
        col3: [
          {
            heading: 'Anti-Fungal',
            items: [
              { name: 'ItzBio SB – 65 mg', link: '/product/SkinCare/ItzBio65' },
              { name: 'ItzBio SB – 130 mg', link: '/product/SkinCare/ItzBio130' }
            ]
          },
          {
            heading: 'Immunity-Booster',
            items: [
              { name: 'CuMax', link: '/product/SkinCare/Cumax' }
            ]
          },
          {
            heading: 'Anti-Allergic',
            items: [
              { name: 'Longy', link: '/product/SkinCare/Longy' }
            ]
          },
          {
            heading: 'Eczema',
            items: [
              { name: 'Imulimus', link: '/product/SkinCare/Imulimus' }
            ]
          }, {
            heading: 'Pigmentation',
            items: [

              { name: 'MelaAct 2.0', link: '/product/SkinCare/Melaact2' }
            ]
          },
        ]
      },
      right: [
        {
          heading: 'Hair Care',
          link: '/HairCareProducts',
          items: [
            { name: 'Ceratina', link: '/product/HairCare/Ceratina' },
            { name: 'Root In 2.5', link: '/product/HairCare/rootin2-5' },
            { name: 'Root In 1.25', link: '/product/HairCare/rootin1-25' },
            { name: 'Root In', link: '/product/HairCare/rootin' },
            { name: 'Root In F', link: '/product/HairCare/rootinf' }
          ]
        },
        {
          heading: 'Medical Engineering',
          link: '/MedicalEnggProducts',
          items: [
            { name: 'Mesojet', link: '/product/Medical-Engineering/Mesojet' },
            { name: 'UM150A', link: '/product/Medical-Engineering/UM150A' }
          ]
        },
        {
          heading: 'Premium',
          link: '/MariniProducts',
          items: [
            { name: 'Marini skinsolutions', link: '/MariniProducts' }
          ]
        }
      ]
    }
  }
];

export default menuData;
